(function () {

  'use strict';

  angular.module('cvsApp')
    .controller('BankAccountInfoCtrl', ["$scope", "$state", "$rootScope", '$stateParams', 'userSession', "commonService", 'addDataService', 'webAnalytics', "userSession", "$anchorScroll", "modifyFormOfPaymentService", "retrieveFormOfPaymentService","accountDataService","cvsAppData" ,"loggerService", "loggerServiceHelper",
          function ($scope, $state, $rootScope, $stateParams, UserSession, commonService, guestDataService, webAnalytics, userSession, $anchorScroll, modifyFormOfPaymentService, RFOP, AccountDataSvc, CAD,loggerService, loggerServiceHelper ) {
        var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED) + loggerServiceHelper.setFlowType(UserSession.paymentType) + loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.AddEditBankAccount));
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.START));


        // $scope.stateParams  = localStorage.getItem('stateParams') ? JSON.parse(localStorage.getItem('stateParams')) : $stateParams;
        // localStorage.removeItem('stateParams');

        /*Scroll to top*/
        cvsUtility.genralPostMessage("SCROLL_TO", {
          "scroll": true
        });
        //cvsUtility.resetSessoinTimeOut();
        var _addModeInd = false;
        $scope.isFEPClient = false;
        $scope.content = wcmContent;
        $stateParams.mopid = localStorage && localStorage.getItem("mopid") ? localStorage.getItem("mopid") : $stateParams.mopid;
        //$scope.stateparamsmopid = localStorage && localStorage.getItem("mopid") ? localStorage.getItem("mopid") : $scope.stateParams.mopid;
        $scope.addNew = $stateParams.mopid == undefined;

        /* 
         * START: GST-35 & GST-54 read from bankInfo directive
         */
        $scope.showmask = true;
        $rootScope.$on('setBankAccountNumber', function (event, data) {
          if ($scope.hasOwnProperty('bankInfoForm') && $scope.bankInfoForm && $scope.bankInfoForm.hasOwnProperty('cardaccount')) {
            $rootScope.bankAccountNum = data.bankAccountNum;
          }
        });

        $scope.updateAccountError = false;
        var utagObj = {};
        if (UserSession.registered) {
          if ($scope.addNew) {
            log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.FLOW.AddBankAccount));

            /**
             * sankar 11/22/2016 - ITPR017031 - add bank info page
             * Added WTS pagename tag
             */
            if (self == top) {
              utagObj.pagename = "PAYMENT-addBank";
            }
            webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "addBank");
          } else {
            log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.FLOW.EditBankAccount));

            /**
             * sankar 11/22/2016 - ITPR017031 - edit bank info page
             * Added WTS pagename tag
             */
            if (self == top) {
              utagObj.pagename = "PAYMENT-editBank";
            }
            webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "editBank");
          }
        } else {

          /**
           * sankar 11/22/2016 - ITPR017031 - add/Edit guest bank info page
           * Added WTS pagename tag
           */
          if (self == top) {
            utagObj.pagename = "PAYMENT-guestAddEditBank";
          }
          webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "guestAddEditBank");
        }
        var stateMopId = $stateParams.mopid; //decodeURIComponent($stateParams.mopid);
        $scope.accountDetails = {};
        $scope.accountDetails = $stateParams.mopid ? UserSession.accountData.getMopById(stateMopId) : UserSession.getNewMopAccountObject("CHECK");
        if (!$scope.accountDetails) {
          $scope.accountDetails = guestDataService.getNewMOP();
          _addModeInd = true;
        }
        $scope.editFromAutoPayments = $stateParams.editMode;
        $scope.primaryAddress = angular.copy($scope.session.accountData.primaryAddress);


        function onGetPaymentSuccess(response) {
          angular.element("#mydiv").hide();
          angular.element("#specialtySpinner").hide();
          angular.element("#loader").hide();
          if (loggerServiceHelper) {
            log.info(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
              loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService"));
          }
          if (response.getError() === '') {

            //log for success retrieveFormOfPayment
            if (loggerServiceHelper) {
              log.info(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService") + loggerServiceHelper.setStatus("SUCCESS") +
                loggerServiceHelper.setDescription(" SUCCESS " + JSON.stringify(response)));
            }

            // update the list of payment methods
            AccountDataSvc.updateListMop(response.getPaymentInfos());

            $rootScope.isCardAddSuccess = true;
            var lastFour = $scope.accountDetails.accountNumber.substring($scope.accountDetails.accountNumber.length - 4);
            $rootScope.addedCardDetails = {accountNumber: lastFour, mopType: $scope.accountDetails.payment.mopType};

            $state.go("payment-methods");

          } else {
            var showError = response.getError();
            var statusCode = showError.statusCode;
            switch (statusCode) {
              case 'DBPL9999': {
                if (log.error && loggerServiceHelper) {
                  log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                }
                var pageError = cvsUtility.getPageError(response, 'Fatal', 'retrieveFormOfPaymentService');
                $scope.referenceId = response.apiResponse.showError.refId;
                $scope.updateAccountError = true;
                $rootScope.$emit("updateAccountError", $scope.updateAccountError);

                setTimeout(function () {
                  document.getElementById('paymentInlineAlert').focus();
                  document.getElementById('paymentInlineAlert').scrollIntoView({
                    behavior: 'smooth'
                  });
                }, 100);

                break;
              }
              case '6006': {
                if (log.error && loggerServiceHelper) {
                  log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                }
                // update the list of payment methods
                AccountDataSvc.updateListMop([]);
                AccountDataSvc.setRecentPaymentMethodId("");
                break;
              }
              default: {
                if (log.error && loggerServiceHelper) {
                  log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                }
                modal.retrievepaymentsmessage.retrievePaymentFailed = true; // Flag to show retrieve payments failed banner
                $rootScope.$emit("retrievePaymentsFailed", modal.retrievepaymentsmessage);

                setTimeout(function () {
                  document.getElementById('retrievePaymentsErrorBlock').focus();
                  document.getElementById('retrievePaymentsErrorBlock').scrollIntoView({
                    behavior: 'smooth'
                  });
                }, 100);
                break;
              }
            }
          }
        }

        /**
         * IM5900218 - Oct 2017 release - IM fix to focus on correct first error field
         * @param bankInfoForm
         */
        $scope.scrollToErrors = function (bankInfoForm) {
          if (bankInfoForm.$error) {
            var error = bankInfoForm.$error;
            var ctrl = angular.element("[name='" + bankInfoForm.$name + "']").find('.ng-invalid');
            if (error) {
              if (ctrl.is('select') && $scope.isMobile) {
                return;
              } else {
                angular.element("[name='" + bankInfoForm.$name + "']").find('.ng-invalid:visible:first').focus();
              }
            }
          }
          /*if ($scope.bankInfoForm.$error) {
              var error = $scope.bankInfoForm.$error;
              if (error.required) {
                  angular.forEach(error.required, function(i, error) {
                      if (i.$invalid === true && error === 0) {
                          angular.element('input.ng-invalid').focus();
                          angular.element('select.ng-invalid').focus();
                      }
                  });
              } else if (error.minlength) {
                  angular.forEach(error.minlength, function(i, error) {
                      if (i.$invalid === true && error === 0) {
                          angular.element('input.ng-invalid').focus();
                      }
                  });
              } else if (error.pattern) {
                  angular.forEach(error.pattern, function(i, error) {
                      if (i.$invalid === true && error === 0) {
                          angular.element('input.ng-invalid').focus();
                      }
                  });
              }
          }*/
        }

        $scope.contactUs = function () {
          var getBrandingInfoObj = CAD.getBrandingInfos();
          if (getBrandingInfoObj != "") {
            if (getBrandingInfoObj[0].clientInfo.clientName == 'FEP') {
              $scope.isFEPClient = true;
            }
          }
          cvsUtility.checkIfFepClient($scope.isFEPClient);
        };

        var formData = $scope.accountDetails;

        $scope.continue = function (bankInfoForm, selection) {
          $scope.isRoutingNumberError = false;
          $scope.updateAccountError = false;

          if (bankInfoForm.$valid) {
            if (!bankInfoForm.cardaccount.value && bankInfoForm.cardaccount.$modelValue != undefined) {
              if ($scope.addNew || $scope.accountDetails.transactionMode === 'ADD') {
                // GST-190 Tagging
                var utagObj = {};
                utagObj.link_name = "Custom: add bank account: save button";
                utagObj.link_trackvars = "events";
                utagObj.link_trackevents = "event00";
                webAnalytics.webTrendsUtag("LINK", utagObj, undefined);

                $scope.accountDetails.cardholder.firstName = bankInfoForm.accountFirstname.$modelValue;
                $scope.accountDetails.cardholder.lastName = bankInfoForm.accountLastname.$modelValue;
                $scope.accountDetails.routingNumber = bankInfoForm.cardrouting.$modelValue;

                // GST-54 send Account Number w/o masking on Edit and ADD screen 
                // $scope.accountDetails.accountNumber = bankInfoForm.cardaccount.$modelValue;
                $scope.accountDetails.accountNumber = $rootScope.bankAccountNum;

                $scope.accountDetails.relationshipToCardHolder = bankInfoForm.accountRelationship.$modelValue;
                // TODO: Handle asyncronous response of adding new MOP success/error
                var addressSelectionMethod = bankInfoForm.primary && bankInfoForm.primary.$modelValue;
                if (addressSelectionMethod && addressSelectionMethod == "primary") {
                  $scope.accountDetails.billingAddress = $scope.primaryAddress;
                }
                if ($scope.accountDetails.billingAddress && bankInfoForm.billingSt1 && bankInfoForm.billingSt1.$modelValue) {
                  $scope.accountDetails.billingAddress = {
                    addressLine1: bankInfoForm.billingSt1.$modelValue,
                    "addressLine2": bankInfoForm.billingSt2.$modelValue,
                    city: bankInfoForm.billingCity.$modelValue,
                    "state": bankInfoForm.billingState.$modelValue,
                    "zipCode": bankInfoForm.billingZip.$modelValue,
                    "zipCodeExt": ""
                  }

                }
                if (UserSession.registered) {
                  $scope.accountDetails.transactionMode = "ADD";
                  if (localStorage) {
                    localStorage.setItem("transactionMode", "ADD");
                  }
                }
                UserSession.addNewMop($scope.accountDetails);
                guestDataService.setNewMop($scope.accountDetails);
                Object.keys(userSession.persit).forEach(function (key) {
                  userSession.persistCopy[key] = userSession.persit[key];
                });
                //$state.go("review-payments");
                if (formData.transactionMode == 'ADD') {
                  var accountNumber = commonService.getEncryptedRSAData($scope.accountDetails.accountNumber);
                  if (!accountNumber || accountNumber == $scope.accountDetails.accountNumber) {
                    $scope.ENCRYPTION_ERROR = true;
                    return;
                  } else {
                    $scope.accountDetails.encryptedAccountNumber = accountNumber;
                  }
                }

                if(formData.transactionMode == 'ADD'){
                  $scope.accountDetails.createdBy = "DIGITAL WEB";
                } 
                 // calling MFOP service only on my account page 
                if ($rootScope.customelementsPayments == true) {
                  modifyFormOfPaymentService.modifyFormOfPayment(formData, function (response) {
                    angular.element("#mydiv").show();
                    angular.element("#specialtySpinner").show();
                    angular.element("#loader").show();
                    if (!response.apiResponse.showError) {

                      RFOP.retrieveFormOfPaymentdata(onGetPaymentSuccess);

                    } else {
                      var header = response.getHeader();
                      var statusCode = header.statusCode;
                      switch (statusCode) {
                        case 'SET_MOP_006':
                        case 'DBPL6009': {
                          var pageError = cvsUtility.getPageError(response, 'Fatal', 'modifyFormOfPayment');
                          var utagObj = {
                            page_error: pageError
                          };
                          webAnalytics.webTrendsUtag("LINK", utagObj, undefined, undefined);
                          $scope.referenceId = response.apiResponse.showError.refId;
                          $scope.isRoutingNumberError = true;
                          setTimeout(function () {
                            document.getElementById('routingErrorBlock').focus();
                            document.getElementById("routingErrorBlock").scrollIntoView({
                              behavior: 'smooth'
                            });
                          }, 200);
                          break;
                        }
                        default: {
                          var pageError = cvsUtility.getPageError(response, 'Fatal', 'modifyFormOfPayment');
                          var utagObj = {
                            page_error: pageError
                          };
                          webAnalytics.webTrendsUtag("LINK", utagObj, undefined, undefined);
                          $scope.referenceId = response.apiResponse.showError.refId;
                          $scope.updateAccountError = true;
                          setTimeout(function () {
                              document.getElementById('paymentInlineAlert').focus();
                              document.getElementById('paymentInlineAlert').scrollIntoView({
                                behavior: 'smooth'
                              });
                            },
                            100);
                        }
                      }
                      angular.element("#mydiv").hide();
                      angular.element("#specialtySpinner").hide();
                      angular.element("#loader").hide();
                    }
                  });
                }

              }
              // EDIT sceario will go this else condition and will call MFOP service 
              else {
                if ($scope.accountDetails) {
                  $scope.accountDetails.cardholder.firstName = bankInfoForm.accountFirstname.$modelValue;
                  $scope.accountDetails.cardholder.lastName = bankInfoForm.accountLastname.$modelValue;
                  $scope.accountDetails.routingNumber = bankInfoForm.cardrouting.$modelValue;
                  $scope.accountDetails.accountNumber = bankInfoForm.cardaccount.$modelValue;
                  $scope.accountDetails.relationshipToCardHolder = bankInfoForm.accountRelationship.$modelValue;
                  // TODO: Handle asyncronous response of adding new MOP success/error
                  var addressSelectionMethod = bankInfoForm.primary && bankInfoForm.primary.$modelValue;
                  if (addressSelectionMethod && addressSelectionMethod == "primary") {
                    $scope.accountDetails.billingAddress = $scope.primaryAddress;
                  }
                  if ($scope.accountDetails.billingAddress) {
                    $scope.accountDetails.billingAddress = {
                      addressLine1: bankInfoForm.billingSt1.$modelValue,
                      "addressLine2": bankInfoForm.billingSt2.$modelValue,
                      city: bankInfoForm.billingCity.$modelValue,
                      "state": bankInfoForm.billingState.$modelValue,
                      "zipCode": bankInfoForm.billingZip.$modelValue,
                      "zipCodeExt": ""
                    }

                  }
                  UserSession.updateMop($scope.accountDetails);
                  //guestDataService.updateMop($scope.accountDetails);
                  if (localStorage) {
                    localStorage.setItem("transactionMode", "EDIT");
                    localStorage.setItem("mopid", $stateParams.mopid);
                  }
                  $scope.accountDetails.transactionMode = "EDIT";
                  formData.createdBy = "DIGITAL WEB";
                  if (formData.payment.method == "CHECK") {
                    formData.achAcceptanceInd = "true"
                  } else {
                    formData.achAcceptanceInd = "";
                  }
                }
                // $state.go("review-payments");

                //Edit bank Account- MOPService Call

                modifyFormOfPaymentService.modifyFormOfPayment(formData, function (response) {
                  if (!response.apiResponse.showError) {
                    $rootScope.isBankAccountUpdateSuccess = true;
                    $state.go("payment-methods");

                  } else if (response.apiResponse.showError) {
                    var pageError = cvsUtility.getPageError(response, 'Fatal', 'modifyFormOfPayment');
                    var utagObj = {
                      page_error: pageError
                    };
                    webAnalytics.webTrendsUtag("LINK", utagObj, undefined, undefined);
                    $scope.referenceId = response.apiResponse.showError.refId;
                    $scope.updateAccountError = true;
                    setTimeout(function () {
                        document.getElementById('paymentInlineAlert').focus();
                        document.getElementById('paymentInlineAlert').scrollIntoView({
                          behavior: 'smooth'
                        });
                      },
                      100);


                  } else {
                    var pageError = cvsUtility.getPageError(response, 'Fatal', 'modifyFormOfPayment');
                    var utagObj = {
                      page_error: pageError
                    };
                    webAnalytics.webTrendsUtag("LINK", utagObj, undefined, undefined);
                    $scope.referenceId = response.apiResponse.showError.refId;
                    $scope.updateAccountError = true;
                    setTimeout(function () {
                        document.getElementById('paymentInlineAlert').focus();
                        document.getElementById('paymentInlineAlert').scrollIntoView({
                          behavior: 'smooth'
                        });
                      },
                      100);

                  }
                });

              }
            } 
            else {
              if ($scope.addNew || _addModeInd) {
                $scope.accountDetails.cardholder.firstName = bankInfoForm.accountFirstname.value;
                $scope.accountDetails.cardholder.lastName = bankInfoForm.accountLastname.value;
                $scope.accountDetails.routingNumber = bankInfoForm.cardrouting.value;
                $scope.accountDetails.accountNumber = bankInfoForm.cardaccount.value;
                $scope.accountDetails.relationshipToCardHolder = bankInfoForm.accountRelationship.value;
                // TODO: Handle asyncronous response of adding new MOP success/error
                var addressSelectionMethod = bankInfoForm.primary && bankInfoForm.primary.value;
                if (addressSelectionMethod && addressSelectionMethod == "primary") {
                  $scope.accountDetails.billingAddress = $scope.primaryAddress;
                }
                if ($scope.accountDetails.billingAddress && !$scope.accountDetails.billingAddress.addressLine1) {
                  $scope.accountDetails.billingAddress = {
                    addressLine1: bankInfoForm.billingSt1.value,
                    "addressLine2": bankInfoForm.billingSt2.value,
                    city: bankInfoForm.billingCity.value,
                    "state": bankInfoForm.billingState.value,
                    "zipCode": bankInfoForm.billingZip.value,
                    "zipCodeExt": ""
                  }

                }
                if (UserSession.registered) {
                  $scope.accountDetails.transactionMode = "ADD";
                }
                UserSession.addNewMop($scope.accountDetails);
                guestDataService.setNewMop($scope.accountDetails);

              } else {
                if ($scope.accountDetails) {
                  $scope.accountDetails.transactionMode = "EDIT";
                }

              }

            }
            // Navigation from select a payment method screen to reviewpayment screen or auto payment screen
            if ($scope.accountDetails.transactionMode == "ADD") {
              console.log("bank account save btn", $rootScope.customelementsPayments);
              if ($rootScope.customelementsPayments == false || $rootScope.customelementsPayments === undefined) {
                if (UserSession.paymentType === 'auto') {
                  log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.FORM_SUBMIT) + loggerServiceHelper.setStep("save&Continue") + loggerServiceHelper.setDescription("navigate to automatic-payments"));
                  $state.go("automatic-payments");
                } else {
                  log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.FORM_SUBMIT) + loggerServiceHelper.setStep("save&Continue") + loggerServiceHelper.setDescription("navigate to review-payments "));
                  $state.go("review-payments");
                }
              } else {
                // $state.go("payment-methods");
              }
            }
            log.info(loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
          }
        };
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setDescription("Add Edit Bank Account Info page load completed"));
      }
    ]);
})();